import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { BerthV2 } from '../types/ViewModel/BerthV2';

type BerthContextType = {
    allBerths: BerthV2[];
    setAllBerths: (berths: BerthV2[]) => void;
};

export const BerthContext = React.createContext<BerthContextType>(undefined!);

export const BerthProvider = ({ children }: ContextProps) => {
    const [allBerths, setAllBerths] = useState<BerthV2[]>([]);

    return (
        <BerthContext.Provider
            value={{
                allBerths,
                setAllBerths,
            }}
        >
            {children}
        </BerthContext.Provider>
    );
};

export const useBerthStore = () => useContext(BerthContext);
